import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Col, Row, Card} from "react-bootstrap";
import Logo from "../assets/images/logo.svg"
import {useNavigate, useLocation} from "react-router-dom";
import OtpInput from 'react-otp-input';
import {TbAlertHexagon} from "react-icons/tb";
import {createVerification, logout, resetVerification, verifyOtp} from "../actions/LoginActions";
import AlertModal from "../components/AlertModal";
import Loader from "../components/Loader";
import LoginImage from "../components/LoginImage";
import useAuthRedirect from "../hooks/auth/useAuthRedirect";
import {ACCESS_TOKEN, AUTH_EMPLOYEEID, AUTH_USERNAME, INITIAL_TOKEN, SU_MANAGEMENT, TRUST_CHOICE} from "../constants";
import {jwtDecode} from "jwt-decode";

const counterTime = 10;

function VerificationCodeSend() {
    const history = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const [otp, setOtp] = useState('');
    const [counter, setCounter] = useState(counterTime);
    const [resetCounter, setResetCounter] = useState(false);
    const [errors, setError] = useState({
        errorMessage: "",
        isError: false
    });
    const [alertModal, setAlertModal] = useState({
        display: false,
        type: "",
        message: ""
    })
    const [verificationType, setVerificationType] = useState({
        type: "",
    });

    useAuthRedirect();

    useEffect(() => {
        const handleBackButton = () => {
            dispatch(logout());
            history("/sign-in");
        };
        window.addEventListener('popstate', handleBackButton);

        return () => {
            window.removeEventListener('popstate', handleBackButton);
        };
    }, []);

    useEffect(() => {
        setVerificationType({
            type: location.state?.type,
        })

        if (counter <= 0) {
            setResetCounter(true)
        } else {
            const timer =
                counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
            return () => clearInterval(timer);
        }
    }, [counter]);

    useEffect(() => {
        if (otp.length < 6) {
            setError({
                errorMessage: "",
                isError: false
            });
        }
    }, [otp]);

    const resendOtp = () => {
        setOtp("");

        dispatch(createVerification(verificationType.type));
    };

    const createVerificationDetails = useSelector(state => state.createVerification)
    const {loading} = createVerificationDetails

    useEffect(() => {
        if (createVerificationDetails.verificationInfo) {
            dispatch(resetVerification())
            setResetCounter(false)
            setCounter(counterTime)
        }
        if (createVerificationDetails.error) {
            setAlertModal({
                display: true,
                type: "error",
                message: "Failed to request verification code"
            })
        }
    }, [createVerificationDetails]);

    const submitHandler = (event) => {
        event.preventDefault();

        dispatch(verifyOtp(otp))
    };

    const verifyOtpDetails = useSelector(state => state.verifyOtp);
    const {loadingOtp} = verifyOtpDetails;

    useEffect(() => {
        if (verifyOtpDetails.verificationOtp?.token) {
            const {token, stage} =  verifyOtpDetails.verificationOtp;

            if (stage === SU_MANAGEMENT) {
                const decoded = jwtDecode(token);

                localStorage.setItem(ACCESS_TOKEN, JSON.stringify(token));
                localStorage.setItem(AUTH_USERNAME, decoded?.UserName)
                localStorage.setItem(AUTH_EMPLOYEEID, decoded?.UserId)
                localStorage.removeItem(INITIAL_TOKEN);
                window.location.href = "/super-admin-management";
            }

            if (stage === TRUST_CHOICE) {
                localStorage.setItem(INITIAL_TOKEN, JSON.stringify(token));
                history("/mfa");
            }
        }

        if (verifyOtpDetails.verificationOtp === null) {
            setError({
                errorMessage: "The Verification Code you entered is incorrect. Please try again.",
                isError: true
            });
        }
    }, [verifyOtpDetails]);

    const closeAlert = () => {
        setAlertModal({
            display: false
        })

        dispatch(resetVerification())
    }

    return (
        <Row className="login-background">
            {alertModal.display &&
                <AlertModal heading={alertModal.message} type={alertModal.type} result={closeAlert}/>}
            {loading && <Loader/>}
            {loadingOtp && <Loader/>}
            <Col lg={{span: 4, offset: 1}} md={{span: 4, offset: 1}}>
                <Card className="card-body">
                    <img src={Logo} alt="logo" className="logo"/>
                    <form className="margin-top">
                        <p className="header">Verification code</p>
                        <p className="sub-header">Please choose any one option to get verification code</p>
                        <OtpInput
                            value={otp}
                            onChange={setOtp}
                            numInputs={6}
                            inputType="number"
                            renderSeparator={<span className="separator"></span>}
                            renderInput={(props) => <input {...props} className="otp-input"/>}
                        />
                        <div className="counter float-right-child">
                            {!resetCounter && <span className="message-2">Resend OTP in </span>}
                            {!resetCounter &&
                                <span className="message-3">00:{(counter).toString().padStart(2, '0')}</span>}
                            {resetCounter && <span className="message-4" onClick={() => resendOtp()}>Resend OTP</span>}
                        </div>
                        <div className="login-button">
                            <button
                                onClick={submitHandler}
                                disabled={otp.length < 6}
                                type="submit"
                                className={`button-solid ${otp.length < 6 ? "button-inactive" : "button-active"} `}
                            >
                                Send Code
                            </button>
                        </div>
                        {errors.isError && <div className="error-message">
                            <TbAlertHexagon className="icon error-icon float-left-child"/>
                            <div className="d-inline message-1 ms-1">{errors.errorMessage}</div>
                        </div>}
                    </form>
                    <div className="copyright">
                        <p className="sub-footer">v2.0</p>
                        <p className="sub-footer">copyright text</p>
                    </div>
                </Card>
            </Col>
            <Col lg={{span: 7, offset: 0}} md={{span: 7, offset: 0}}>
                <LoginImage/>
            </Col>
        </Row>
    );
}

export default VerificationCodeSend;